import React from 'react';

interface ExternalLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {}

const ExternalLink = ({children, ...props}: ExternalLinkProps) => {
    return <a {...props} target={'_blank'} rel='noreferrer'>{children}</a>
}

export default ExternalLink;
